import { NumberField as BaseNumberField } from "@base-ui/react/number-field";
import { useTheme } from "@mui/material";
import { Field } from "@base-ui/react/field";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Controller, useFormContext } from "react-hook-form";
import { getNumberFieldStyles } from "./NumberField.styles";

export default function NumberField({
  name,
  defaultValue,
  min,
  max,
}: BaseNumberField.Root.Props & {
  name: string;
  defaultValue?: number;
}) {
  const { control } = useFormContext();
  const theme = useTheme();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({
        field: { ref, name, value, onBlur, onChange },
        fieldState: { invalid, isTouched, isDirty, error },
      }) => {
        const styles = getNumberFieldStyles(theme, invalid);
        return (
          <Field.Root
            name={name}
            invalid={invalid}
            touched={isTouched}
            dirty={isDirty}
            style={styles.field}
          >
            <BaseNumberField.Root
              value={value}
              min={min}
              max={max}
              onValueChange={onChange}
            >
              <BaseNumberField.Group style={styles.group}>
                <BaseNumberField.Decrement style={styles.decrement}>
                  <RemoveIcon />
                </BaseNumberField.Decrement>
                <BaseNumberField.Input
                  ref={ref}
                  onBlur={onBlur}
                  style={styles.input}
                />
                <BaseNumberField.Increment style={styles.increment}>
                  <AddIcon />
                </BaseNumberField.Increment>
              </BaseNumberField.Group>
            </BaseNumberField.Root>
            <Field.Error match={!!error} style={styles.error}>
              {error?.message}
            </Field.Error>
          </Field.Root>
        );
      }}
    />
  );
}
